import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface IProps {
	changePaymentTypeId: (value: string) => void;
}

export const PaymentTypeIdField: React.FC<IProps> = ({ changePaymentTypeId }) => {
	const { t } = useTranslation('error');
	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterPaymentTypeId') }], [t]);

	return (
		<FormInput
			testId="PaymentTypeIdField"
			name="paymentTypeId"
			label="paymentTypeIdLabel"
			onChange={changePaymentTypeId}
			validationRules={validationRules}
		/>
	);
};
